/* ==================================================================
   North Shore Peptides — COA directory search filter
   ================================================================== */
(function () {
  'use strict';

  function initCoa(root) {
    if (!root || root.dataset.npInit === 'true') return;
    root.dataset.npInit = 'true';

    var input = root.querySelector('[data-coa-search]');
    var items = Array.prototype.slice.call(root.querySelectorAll('.np-coa-card'));
    var noResults = root.querySelector('.np-coa-noresults');
    var count = root.querySelector('[data-coa-count]');
    if (!input || !items.length) return;

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var shown = 0;
      items.forEach(function (item) {
        var match = !q || (item.dataset.name || '').indexOf(q) !== -1;
        item.hidden = !match;
        if (match) shown++;
      });
      if (noResults) noResults.hidden = shown !== 0;
      if (count) count.textContent = shown;
    });
  }

  function initAll() { document.querySelectorAll('.np-coa-page').forEach(initCoa); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.np-coa-page');
    if (el) { el.dataset.npInit = ''; initCoa(el); }
  });
})();
